import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import BudgetAllocationCreatePage from './budget-allocation-create'
import BudgetAllocationListPage from './budget-allocation-list'

const budgetAllocationRoutes: Route[] = [
  {
    path: Paths.BUDGET_ALLOCATION_LIST_PAGE,
    element: <BudgetAllocationListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.BUDGET_ALLOCATION_CREATE_PAGE,
    element: <BudgetAllocationCreatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default budgetAllocationRoutes
